export default {
  "Grey": {
    "Black Ash": "#3B3B3B",
    "Dim Grey": "#707070",
    "Dust Grey": "#969696",
    "Light Grey": "#B3B3B3",
    "Gainsboro": "#E6E6E6",
    "Alabaster": "#F2F2F2"
  },
  "Rain": {
    "Shark": "#1F2323",
    "Atomic": "#455559",
    "Slate": "#6D8088",
    "Aqua Island": "#9ECDDB",
    "Rain Sky": "#DCEAEF",
    "Aqua Blue": "#F7FBFD"
  },
  "Blue": {
    "Lochmara": "#028BCF",
    "Danube": "#7FADDC",
    "Spindle": "#B3CFEA",
    "Solitude": "#ECF8FE"
  },
  "Sea": {
    "Light Sea": "#21B7C4",
    "Turquoise": "#50E2C3",
    "Blizzard Blue": "#ACECE7"
  },
  "Purple": {
    "Indigo": "#4A2DBE",
    "Portage": "#A684F5",
    "Lavender": "#EDE5FF"
  },
  "Eagle": {
    "Dark Cerulean": "#00A4D1",
    "Cerulean": "#00B4E6",
    "Dark Turquoise": "#00CBE6",
    "Dark Opal": "#00DBCD",
    "Opal": "#00F0E0"
  },
  "Gold": {
    "Brandy": "#DAC08B",
    "Beige": "#FFF9EB"
  },
  "Red": {
    "Salmon Red": "#FB7979"
  },
  "Green": {
    "Spring Green": "#21D48F"
  },
  "Black": {
    "Black": "#000000"
  },
  "White": {
    "White": "#FFFFFF"
  },
  "Aragon Brand": {
    "Primary": "=Purple.Indigo",
    "Secondary": "=Sea.Turquoise",
    "Black Ash": "=Grey.Black Ash",
    "Gradient Start": "=Eagle.Cerulean",
    "Gradient End": "=Eagle.Opal"
  },
  "Aragon UI": {
    "gradientStart": "=Eagle.Cerulean",
    "gradientEnd": "=Eagle.Opal",
    "gradientStartActive": "=Eagle.Dark Cerulean",
    "gradientEndActive": "=Eagle.Dark Opal",
    "gradientText": "=White.White",
    "mainBackground": "=Rain.Aqua Blue",
    "mainBgGradientStart": "=Rain.Rain Sky",
    "mainBgGradientEnd": "=Rain.Aqua Blue",
    "secondaryBackground": "=Rain.Rain Sky",
    "contentBackground": "=White.White",
    "contentBackgroundActive": "=Grey.Alabaster",
    "contentBorder": "=Grey.Gainsboro",
    "contentBorderActive": "=Grey.Light Grey",
    "disabled": "=Grey.Gainsboro",
    "disabledText": "=White.White",
    "infoBackground": "=Blue.Solitude",
    "infoPermissionsBackground": "=Gold.Beige",
    "infoPermissionsIcon": "=Gold.Brandy",
    "shadow": "=Grey.Alabaster",
    "text": "=Black.Black",
    "textPrimary": "=Aragon UI.text",
    "textDimmed": "=Grey.Black Ash",
    "textSecondary": "=Grey.Dim Grey",
    "textTertiary": "=Grey.Light Grey",
    "accent": "=Eagle.Dark Turquoise",
    "positive": "=Green.Spring Green",
    "positiveText": "=White.White",
    "negative": "=Red.Salmon Red",
    "negativeText": "=White.White",
    "badgeAppBackground": "=Purple.Lavender",
    "badgeAppForeground": "=Purple.Portage",
    "badgeIdentityBackground": "=Rain.Rain Sky",
    "badgeIdentityForeground": "=Rain.Slate",
    "badgeNotificationBackground": "=Aragon UI.positive",
    "badgeNotificationForeground": "=Aragon UI.positiveText",
    "badgeInfoBackground": "=Rain.Rain Sky",
    "badgeInfoForeground": "=Rain.Slate",
    "selectionBackground": "#B2D7FF",
    "selectionForeground": "=Aragon UI.textPrimary"
  },
  "Aragon UI Dark": {
    "gradientStart": "=Eagle.Cerulean",
    "gradientEnd": "=Eagle.Opal",
    "gradientStartActive": "=Eagle.Dark Cerulean",
    "gradientEndActive": "=Eagle.Dark Opal",
    "gradientText": "=White.White",
    "mainBackground": "=Rain.Aqua Blue",
    "mainBgGradientStart": "=Rain.Rain Sky",
    "mainBgGradientEnd": "=Rain.Aqua Blue",
    "secondaryBackground": "=Rain.Rain Sky",
    "contentBackground": "=Rain.Shark",
    "contentBackgroundActive": "=Grey.Alabaster",
    "contentBorder": "=Grey.Gainsboro",
    "contentBorderActive": "=Grey.Light Grey",
    "disabled": "=Grey.Light Grey",
    "disabledText": "=Grey.Dim Grey",
    "infoBackground": "=Blue.Solitude",
    "infoPermissionsBackground": "=Gold.Beige",
    "infoPermissionsIcon": "=Gold.Brandy",
    "shadow": "=Grey.Alabaster",
    "text": "=White.White",
    "textPrimary": "=Aragon UI Dark.text",
    "textDimmed": "=Grey.Alabaster",
    "textSecondary": "=Grey.Dust Grey",
    "textTertiary": "=Grey.Dim Grey",
    "accent": "=Eagle.Dark Turquoise",
    "positive": "=Green.Spring Green",
    "positiveText": "=White.White",
    "negative": "=Red.Salmon Red",
    "negativeText": "=White.White",
    "badgeAppBackground": "=Purple.Lavender",
    "badgeAppForeground": "=Purple.Portage",
    "badgeIdentityBackground": "=Rain.Rain Sky",
    "badgeIdentityForeground": "=Rain.Slate",
    "badgeNotificationBackground": "=Aragon UI Dark.positive",
    "badgeNotificationForeground": "=Aragon UI Dark.positiveText",
    "badgeInfoBackground": "=Rain.Rain Sky",
    "badgeInfoForeground": "=Rain.Slate",
    "selectionBackground": "#B2D7FF",
    "selectionForeground": "=Aragon UI.textPrimary"
  }
}
